const makeSelectizeOnEach = require('../functions/makeSelectizeOnEach.js');
const TipoVisualizacaoDados = require('./TipoVisualizacaoDados');
const inputMasks = require('../helpers/inputMasks.js');
const to_array = require('./to_array');
const GlobalAlerts = require('./GlobalAlerts');
const Lang = require('lang');

import CustomTooltip from './CustomTooltip';

function LimitesDeDespesa() {
  settingsDefaultElements()
}

/***************************************************************
 *
 * SETTINGS GERAIS DA PÁGINA
 *
 **************************************************************/

/**
 * Configurações dos eventos gerais da página
 */
function settingsDefaultElements() {
  const saveAllBtn = document.getElementById('save-all');
  const selectCurrency = document.querySelector('#idMoeda');

  saveAllBtn.addEventListener('click', handlerClickButtonSaveAll);
  selectCurrency.addEventListener('change', (event) => {
    handlerChangeCurrency(event.target);
  });

  // definindo o valor atual do id da moeda que está em exibição
  selectCurrency.dataset.limitIdCurrency = selectCurrency.value;
}

/**
 * Evento de click do botão para atualizar os dados da política
 * e os limites que ela possui
 *
 * @param {Event} event
 */
function handlerClickButtonSaveAll() {
  const rows = to_array(document.getElementsByClassName('js-limite-de-despesa'));
  const promises = [sendLimitExpenseTypeData(rows)];

  nifty.body.overlay({ fixed: true });
  nifty.body.overlay('show');

  promises.push(sendPolicyData());
  return Promise.all(promises)
    .then((response) => {
      GlobalAlerts.createAndShow({
        title: Lang.get('js/src/functions/LimitesDeDespesa.success'),
        message: Lang.get('js/src/functions/LimitesDeDespesa.expense_limits_successfully_updated'),
      });

      const inputMoeda = document.querySelector('#idMoeda');
      refreshContentDataLimits(inputMoeda);
      return response;
    })
    .catch((error) => {
      GlobalAlerts.createAndShow({
        title: Lang.get('js/src/functions/LimitesDeDespesa.ops'),
        message: Lang.get('js/src/functions/LimitesDeDespesa.expense_limit_update_error_message'),
        type: 'danger'
      });
    })
    .then(() => nifty.body.overlay('hide'));
}

/**
 * Evento de click no botão de mudar moeda, responsável por
 * alterar os limites exibidos na tabela e alterar a label da moeda
 * que está sendo modificada
 *
 * @param {Element} event
 */
function handlerChangeCurrency(inputMoeda) {
  const currentIsoMoeda = document.querySelector('#isoMoeda').textContent;
  nifty.body.overlay({ fixed: true });

  bootbox.dialog({
    title: Lang.get('js/src/functions/LimitesDeDespesa.do_you_wish_to_save_the_limits_defined'),
    message: Lang.get('js/src/functions/LimitesDeDespesa.confirm_if_user_want_to_save_limits_defined_before_change_limits_for_the_other_currency', {
      iso_moeda: currentIsoMoeda,
    }),
    buttons: {
      cancel: {
        label: Lang.get('js/common/form/button.discard_changes'),
        className: 'btn-danger',
        callback: function () {
          refreshContentDataLimits(inputMoeda)
            .then(() => nifty.body.overlay('hide'));
        }
      },
      confirm: {
        label: Lang.get('js/common/form/button.save'),
        className: 'btn-success',
        callback: function () {
          Promise.resolve(handlerClickButtonSaveAll())
            .then(() => {
              nifty.body.overlay('show');
              refreshContentDataLimits(inputMoeda);
            })
            .then(() => nifty.body.overlay('hide'))
            .catch(() => {
              nifty.body.overlay('hide');
              restoreValueSelectInputCurrency(inputMoeda);
            });
        }
      }
    },
    onEscape: function () {
      restoreValueSelectInputCurrency(inputMoeda);
    }
  });
}

/**
 * Tratar a obtenção dos dados de limite tipos da política
 * com base na moeda selecionada na interface, e atualiazar
 * as informações na tela
 *
 * @param {Element} inputMoeda
 */
function refreshContentDataLimits(inputMoeda) {
  const idLimitePolitica = inputMoeda.dataset.limitPolicyId;

  const promise = getLimitsByCurrency(idLimitePolitica, inputMoeda.value);
  return Promise.resolve(promise)
    .then((response) => {
      updateLabelIsoCurrency(inputMoeda.textContent);
      renderLimitsAfterChangeCurrency(response.data);
      // definindo o valor atual do id da moeda que está em exibição
      inputMoeda.dataset.limitIdCurrency = inputMoeda.value;
    })
    .catch((error) => {
      GlobalAlerts.createAndShow({
        title: Lang.get('js/src/functions/LimitesDeDespesa.ops'),
        message: error.message,
        type: 'danger'
      })
    })
}

/**
 * Renderizar o html retornado pela request e reaplicar os
 * listerners dos dos elementos que estão dentro deste conteúdo
 *
 * @param {string} data
 */
function renderLimitsAfterChangeCurrency(htmlToRender) {
  const holderElementTable = document.querySelector('#limiteDespesaTipoHolder');
  let tableContent = document.querySelector('#limiteDespesaTipo');
  const viewType = tableContent.dataset.view;

  $('.js-custom-tooltip').tooltip('dispose');

  holderElementTable.innerHTML = htmlToRender;

  makeSelectizeOnEach('.dynamic-select');
  CustomTooltip('.js-custom-tooltip');
  TipoVisualizacaoDados.init();
  TipoVisualizacaoDados.removeActiveButtons();

  inputMasks.init();  //refazer as mascaras dos inputs

  tableContent = document.querySelector('#limiteDespesaTipo');
  tableContent.setAttribute('data-view', viewType);
  holderElementTable.querySelector(`[data-view-type="${viewType}"]`).classList.add('active');
}

/**
 * Atualizar o a label que indica qual moeda está tendo seus valores
 * atualizados na interface
 *
 * @param {string} isoMoeda
 */
function updateLabelIsoCurrency(isoMoeda) {
  const labelCurrencyIso = document.querySelector('#isoMoeda');
  labelCurrencyIso.innerHTML = isoMoeda;
}

/**
 * Obter os dado do limite da interface para o envio da request
 *
 * @param {Element} row
 */
function getLimiteExpenseTypeDataToSend(row) {
  const inputMoeda = document.querySelector('#idMoeda');
  let inputs = to_array(row.querySelectorAll('input, select'));

  inputs = inputs.filter(function (input) {
    return input.name !== '_token';
  }).filter(function (input) {
    return input.name !== '_method';
  }).filter(function (input) {
    if (input.type === 'radio') {
      return input.checked;
    }
    return true;
  }).reduce(function (prev, next) {
    const name = next.name.replace(/\[[0-9]+\]/, '');
    prev[name] = next.value;
    return prev;
  }, {});

  inputs.idMoeda = inputMoeda.dataset.limitIdCurrency;
  inputs.idDespesaLimitePolitica = inputMoeda.dataset.limitPolicyId;

  return inputs;
}

/**
 * Restaurar o valor do selectize de moeda em casos que a request
 * para salvar os dados dos limites configuradas não for realizado
 * com sucesso
 *
 * @param {Element} inputMoeda
 */
function restoreValueSelectInputCurrency(inputMoeda) {
  const inputMoedaSelectize = $(inputMoeda)[0].selectize;
  inputMoedaSelectize.setValue(inputMoeda.dataset.limitIdCurrency, true);
}

/***************************************************************
 *
 * REQUESTS
 *
 **************************************************************/

/**
 * Enviar request ajax com os limites do tipo utilizada para o
 * create e update de limites por tipo
 *
 * @param {Element} row
 */
function sendLimitExpenseTypeData(rows) {
  const data = [];
  rows.forEach(row => {
    const dataRow = getLimiteExpenseTypeDataToSend(row);

    const idTipo = row.dataset.tipo;
    if (idTipo !== undefined) {
      dataRow.idDespesaTipo = idTipo
    }

    const idLimitePolitica = row.dataset.limite;
    if (idLimitePolitica !== undefined) {
      dataRow.idLimitePolitica = idLimitePolitica
    }

    data.push(dataRow);
  });

  const ajax = $.ajax({
    method: 'POST',
    url: route('app.settings.limites-de-despesa-tipos.save-all'),
    data: {
      'limites': JSON.stringify(data)
    }
  });
  return Promise.resolve(ajax);
}

/**
 * Enviar com uma request ajax os dados gerais da política
 * como descrição, dias corridos e etc
 */
function sendPolicyData() {
  const inputCheckBoxLimitePorRateio = document.querySelector('#usarValorLimitePorRateio');
  const usarvalorLimitePorRateio = (document.body.contains(inputCheckBoxLimitePorRateio))
    ? + inputCheckBoxLimitePorRateio.checked // forçando que o boolean seja um número inteiro
    : null;


  const dataDescription = {
    id: document.querySelector('#description').dataset.idDescription,
    description: document.querySelector('#description').value,
    daysBehind: document.querySelector('#diasCorridos').value,
    daysAhead: document.querySelector('#diasFuturos').value,
    usarValorLimitePorRateio: usarvalorLimitePorRateio
  };

  const ajax = $.ajax({
    method: 'PATCH',
    url: route('app.settings.limites-de-despesa.update', {
      limites_de_despesa: dataDescription.id
    }),
    data: {
      descricao: dataDescription.description,
      diasCorridos: dataDescription.daysBehind,
      diasFuturos: dataDescription.daysAhead,
      usarValorLimitePorRateio: dataDescription.usarValorLimitePorRateio
    }
  });

  return Promise.resolve(ajax);
}

/**
 * Realizar uma request ajax para obter o html necessário para atualizar
 * a tabela com todos os limites de políticas de acordo com a moeda selecionada
 * pelo usuário na interface
 *
 * @param {int} idLimitePolitica
 * @param {int} idMoeda
 */
function getLimitsByCurrency(idLimitePolitica, idMoeda) {
  return $.ajax({
    method: 'GET',
    url: route('app.settings.limites-de-despesa.get-limite-tipos-por-politica-moeda', {
      idLimitePolitica: idLimitePolitica,
      idMoeda: idMoeda
    })
  });
}

exports.init = LimitesDeDespesa;
